interface HospitalClaimDetailsProps {
  onDownload: () => void;
  formUrl: string;
}

export const HospitalClaimDetails: React.FC<HospitalClaimDetailsProps> = ({
  onDownload,
  formUrl,
}) => {
  return (
    <div className="mt-5 space-y-4">
      <p className="text-lg leading-7 text-[#2e313f]">
        If you were hurt in an accident and need to file a claim, don’t worry —
        it’s easy!
        <br /> Just download the Accident Claim Form, fill it out, and include
        any documents that show
        <br /> what happened and what treatment you received.
      </p>

      <div>
        <p className="font-semibold text-[#2e313f] text-2xl mb-2">
          Here's how:
        </p>
        <ol className="list-decimal pl-5 space-y-3 text-[#2e313f] text-lg marker:font-bold">
          <li>
            <span className="font-semibold">
              Download the Accident Claim Form
            </span>
            and complete all sections:
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>
                <strong>Section I - Employee's Statement</strong>
              </li>
              <li>
                <strong>Section II - Authorization</strong>
              </li>
              <li>
                <strong>Section III - Physician's Statement</strong>
              </li>
            </ul>
          </li>
          <li>
            <span className="font-semibold">Attach supporting documents</span>
          </li>
          <li>
            <span className="font-semibold">Submit your claim</span>
          </li>
          <li>
            <span className="font-semibold">Need help?</span> Call (866)
            274-9887
          </li>
        </ol>
      </div>

      <hr className="w-[70%]" />

      <div className="space-y-1 text-[#2e313f] text-lg">
        <p className="font-semibold">Where do you send it?</p>
        <p>
          <strong>Email:</strong> EquitableClaims@yourbenefitexpert.com
        </p>
        <p>
          <strong>Fax:</strong> (866) 376-9480
        </p>
        <p className="font-semibold">Mail:</p>
        <p>Group Claims Department</p>
        <p>P.O. Box 9757</p>
        <p>Portland, ME 04104</p>
      </div>

      <button
        onClick={onDownload}
        className="w-full md:w-auto bg-primary text-white px-12 mt-2 py-4 rounded-full text-2xl uppercase max-sm:text-base"
      >
        DOWNLOAD CLAIM FORM
      </button>
    </div>
  );
};
